module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<textarea placeholder="' +
((__t = ( placeholder )) == null ? '' : __t) +
'">' +
((__t = ( value )) == null ? '' : __t) +
'</textarea>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/ejs-loader!./~/icarus-forms/module/js/templates/controls/textarea.ejs
// module id = 208
// module chunks = 2 3